export default [
    {
        path : '/company/:companyId/module/:moduleId/menu/:menuId/export-datasheet/:pageId',
        component: () => import('@/views/page/company/procurement/datasheet/Show'),
        name : 'export-datasheet',
        meta : {
            requiresAuth: true
        }
    }
]